'use client';

import Image from 'next/image';
import InfiniteImageTicker from './InfiniteImageTicker';
import Link from 'next/link';

export default function Footer() {
  return (
    <div>
      <section
        className="relative w-full py-16 bg-cover bg-center mt-16 bg-base-content flex flex-col items-center justify-center text-center"
        aria-labelledby="testimonial-section"
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-base-100 w-[50vw]">
          Let’s create together
        </h2>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-base-100 w-[50vw] mt-4">
          We’d love to work with you
        </h2>
        <Link
          href="/contact-us"
          className="btn btn-primary mt-8 btn-lg min-h-[44px] min-w-[44px] flex items-center justify-center"
        >
          Contact Us
        </Link>
        <div className="mt-16">
          <InfiniteImageTicker
            images={[
              {
                src: '/images/tickerImage0.avif',
                alt: 'Custom software development services by omkode for businesses in Toronto, Calgary, and Vancouver looking for tailored solutions',
              },
              {
                src: '/images/tickerImage1.avif',
                alt: 'Web application development by omkode using modern technologies to build scalable platforms for businesses in Toronto, Calgary, and Vancouver',
              },
              {
                src: '/images/tickerImage2.avif',
                alt: 'Mobile app development services from omkode for iOS and Android, delivering seamless user experiences for Toronto, Calgary, and Vancouver businesses',
              },
              {
                src: '/images/tickerImage3.avif',
                alt: 'Cloud computing solutions and scalable infrastructure by omkode to optimize business operations in Toronto, Calgary, and Vancouver',
              },
              {
                src: '/images/tickerImage4.avif',
                alt: 'UI/UX design services by omkode for creating intuitive and user-centered digital experiences for businesses in Toronto, Calgary, and Vancouver',
              },
              {
                src: '/images/tickerImage5.avif',
                alt: 'Agile software development methodology at omkode for fast and efficient project delivery for Toronto, Calgary, and Vancouver businesses',
              },
              {
                src: '/images/tickerImage6.avif',
                alt: 'Seamless software integrations and API development by omkode to connect systems effortlessly for businesses in Toronto, Calgary, and Vancouver',
              },
              {
                src: '/images/tickerImage7.avif',
                alt: 'Consulting services for custom software solutions by omkode to help businesses succeed in Toronto, Calgary, and Vancouver',
              },
              {
                src: '/images/tickerImage8.avif',
                alt: 'omkode’s end-to-end web development services for modern businesses in Toronto, Calgary, and Vancouver looking to innovate online',
              },
            ]}
          />
        </div>
      </section>

      <footer className="footer bg-base-200 text-base-content p-10 grid grid-cols-1 md:grid-cols-6 gap-8">
        <aside>
          <Link
            href={'/home'}
            className="flex items-center gap-2 text-xl font-extrabold brand-font"
          >
            <Image
              src="/images/logoBlue.svg"
              alt="omkode logo representing innovative software development solutions"
              width={40}
              height={40}
            />
          </Link>
          <p>
            Copyright © {new Date().getFullYear()} omkode - All rights reserved
          </p>
        </aside>
        <nav>
          <h6 className="footer-title">Our Services</h6>
          <Link className="link link-hover" href="/our-services#e-commerce">
            E-Commerce
          </Link>
          <Link
            className="link link-hover"
            href="/our-services#web-development"
          >
            Web Development
          </Link>
          <Link
            className="link link-hover"
            href="/our-services#mobile-development"
          >
            Mobile Development
          </Link>
          <Link className="link link-hover" href="/our-services#branding">
            Branding
          </Link>
        </nav>
        <nav>
          <h6 className="footer-title">Company</h6>
          <Link className="link link-hover" href="/">
            Home
          </Link>
          <Link className="link link-hover" href="/our-services">
            Services
          </Link>
          <Link className="link link-hover" href="/works">
            Works
          </Link>
          <Link className="link link-hover" href="/about">
            About Us
          </Link>
          <Link className="link link-hover" href="/blogs">
            Blogs
          </Link>
          <Link className="link link-hover" href="/contact-us">
            Contact
          </Link>
        </nav>
        <nav>
          <h6 className="footer-title">Legal</h6>
          <Link className="link link-hover" href="/terms">
            Terms of Use
          </Link>
          <Link className="link link-hover" href="/privacy">
            Privacy Policy
          </Link>
          <Link className="link link-hover" href="/cookies">
            Cookie Policy
          </Link>
        </nav>
        <aside>
          <h6 className="footer-title">Contact Us</h6>
          <p>Omkde</p>
          <p>7895 Jane St</p>
          <p>Concord, ON L4K 0K2</p>
          <p>Phone: (647) 632 1699</p>
          <p>Email: info@omkode.com</p>
        </aside>
        <nav>
          <h6 className="footer-title">Social</h6>
          <div className="grid grid-flow-col gap-4">
            <a href="https://x.com/omkode" target="_blank">
              <svg
                xmlns="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/omkode.official/"
              target="_blank"
            >
              <svg
                role="img"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title />
                <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/omkode" target="_blank">
              <svg
                fill="#000000"
                height="24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-143 145 512 512"
              >
                <path d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z M41.4,508.1H-8.5V348.4h49.9V508.1z M15.1,328.4h-0.4c-18.1,0-29.8-12.2-29.8-27.7c0-15.8,12.1-27.7,30.5-27.7 c18.4,0,29.7,11.9,30.1,27.7C45.6,316.1,33.9,328.4,15.1,328.4z M241,508.1h-56.6v-82.6c0-21.6-8.8-36.4-28.3-36.4 c-14.9,0-23.2,10-27,19.6c-1.4,3.4-1.2,8.2-1.2,13.1v86.3H71.8c0,0,0.7-146.4,0-159.7h56.1v25.1c3.3-11,21.2-26.6,49.8-26.6 c35.5,0,63.3,23,63.3,72.4V508.1z"></path>{' '}
              </svg>
            </a>
          </div>
        </nav>
      </footer>
    </div>
  );
}
